import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import Img from "gatsby-image/withIEPolyfill"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { contentfulMapToLocalized } from "../../helpers.js"
import defaultRTRenderOptions from "../../../contentful/rich-text-renderer-options"
import 'lazysizes'

class LeftAlignedImageBlock extends React.Component {
  render() {
    let {sys: { id }, fields:  { title, image, text, extraAttributes }} = this.props.node
    let contentfulImage = get(image, 'en-US.fields')
    contentfulImage = contentfulMapToLocalized(contentfulImage)
    
    const options = {
      ...defaultRTRenderOptions
    }
    
    return (
      <div className="row align-items-center block-image-aligned block-image-aligned_left" id={`left_aligned_block-${id}`}>
        <div className="col-md-6">
          <img src={`${contentfulImage.file.url}?w=120`} 
            data-sizes="(max-width: 340px) 340px, (max-width: 520px) 520px, 720px"
            data-src={`${contentfulImage.file.url}?fm=jpg&fl=progressive`} 
            data-srcset={[720, 520, 340].map((width) => `${contentfulImage.file.url}?w=${width}&fit=scale, `)}
            alt={contentfulImage.description} 
            className="img-fluid lazyload"  />
        </div>
        <div className="col-md-6">
          {documentToReactComponents(text['en-US'], options)}
        </div>
      </div>
    )
  }
}

export default LeftAlignedImageBlock
